<template>
  <teleport to="#app">
    <oxd-dialog
      v-if="showModal"
      class="orangehrm-googlemap-dialog orangehrm-dialog-popup"
      @update:show="onCancel"
    >
      <div class="orangehrm-modal-header">
        <oxd-text type="card-title">{{ title }}</oxd-text>
      </div>
      <div class="orangehrm-text-center-align">
        <oxd-text type="card-body" v-for="(stitle, i) in subtitle" :key="i">
          {{ stitle }} <br />
        </oxd-text>
      </div>

      <template v-if="employees && employees.length > 0">
        <oxd-divider />
        <oxd-grid class="orangehrm-employees-container">
          <oxd-grid-item>
            <oxd-input-field
              v-model="employeeId"
              type="select"
              required
              :options="employees"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field required type="date" v-model="date" />
          </oxd-grid-item>
          <oxd-grid-item class="orangehrm-radio-container">
            <oxd-input-field
              v-model="ottype"
              type="radio"
              required
              option-label="增加"
              value="increase"
            />
            <oxd-input-field
              v-model="ottype"
              type="radio"
              required
              option-label="扣減"
              value="reduce"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              v-model="val"
              type="input"
              required
              placeholder="OT數量(半小時設定 0.5)"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <oxd-input-field
              type="textarea"
              v-model="remark"
              placeholder="備注或原因"
            />
          </oxd-grid-item>
        </oxd-grid>
      </template>

      <div class="orangehrm-modal-footer">
        <oxd-button
          label="取消"
          :display-type="cancelButtonType"
          class="orangehrm-button-margin"
          @click="onCancel"
        />
        <oxd-button
          :icon-name="icon"
          label="確定"
          :display-type="confirmButtonType"
          class="orangehrm-button-margin"
          @click="onConfirm"
        />
      </div>
    </oxd-dialog>
  </teleport>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';
import {ref} from 'vue';

export default {
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    initItems: {
      type: Array,
      required: true,
    },
    initTitle: {
      type: String,
      required: true,
    },
    initSubtitle: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
      title: this.initTitle,
      subtitle: this.initSubtitle,
      employees: this.initItems,
      reject: null,
      resolve: null,
      date: new Date().toISOString().split('T')[0],
      employeeId: null,
      ottype: null,
      val: null,
      remark: null,
    };
  },
  methods: {
    reset() {
      this.employeeId = null;
      this.ottype = null;
      this.val = null;
      this.remark = null;
      this.date = new Date().toISOString().split('T')[0];
    },
    onConfirm() {
      if (!this.employeeId?.id) {
        alert('請選擇員工');
      } else if (!this.date) {
        alert('請選擇日期');
      } else if (!this.ottype) {
        alert('請選擇增加或扣減OT');
      } else if (!this.val) {
        alert('請輸入OT數量');
      } else if (parseFloat(this.val) > 99) {
        alert('OT數量最大不可以超過99');
      } else {
        this.showModal = false;
        let data = {
          employeeId: this.employeeId?.id,
          ottype: this.ottype,
          val: this.val,
          remark: this.remark,
          date: this.date,
        };
        this.reset();
        this.resolve && this.resolve(data);
      }
    },
    onCancel() {
      console.log('date onCancel', this.date);
      this.reset();
      this.showModal = false;
    },

    showDialog(recordar, data) {
      return new Promise((resolve, reject) => {
        this.showModal = true;
        this.$nextTick(() => {
          this.title = ref(this.initTitle);
          this.subtitle = ref(this.initSubtitle);
          this.employees = ref(this.initItems);
          this.resolve = ref(resolve);
          this.reject = ref(reject);
        });
      });
    },
  },
};
</script>

<style src="./dialog.scss" lang="scss" scoped></style>
<style type="text/css">
.orangehrm-employees-container {
  max-width: 400px;
  margin: auto !important;
}
.orangehrm-radio-container {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 可选：如果需要间隔 */
  gap: 1rem; /* 可选：设置按钮之间的间隔 */
}
.orangehrm-radio-container .oxd-input-field {
  display: inline-flex;
  align-items: center;
}
</style>
